import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import global from '../../common/global';
import { normal } from '../defaultSpacing';
import signLog from '@/components/sign-log';
import util from '@/common/util';
import BannerButton from '../../components/banner-button.vue';
export default {
    i18next: {
        ns: 'md-cta-two-column-simple'
    },
    data: function() {
        return {
            sizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 340,
                mobileHeight: 300,
                ratio: 23,
                mobileRatio: 66
            },
            minHeight: '',
            type: 'color',
            pictureOption: {},
            backgroundColor: '',
            title: '',
            subTitle: '',
            leftButtonOption: {},
            rightButtonOption: {},
            leftType: 'color',
            leftBackgroundColor: '',
            leftPictureOption: {},
            rightType: 'color',
            rightBackgroundColor: '',
            rightPictureOption: {},
            leftTitle: '',
            leftDesc: '',
            rightTitle: '',
            rightDesc: '',
            leftButtonAlign: 'center',
            rightButtonAlign: 'center',
            ...normal
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        usePicture() {
            if (!this.isMobile) {
                return (
                    this.pictureOption.src || this.pictureOption.mobileSrc || ''
                );
            } else {
                return (
                    this.pictureOption.mobileSrc || this.pictureOption.src || ''
                );
            }
        },
        useLeftPicture() {
            if (!this.isMobile) {
                return (
                    this.leftPictureOption.src ||
                    this.leftPictureOption.mobileSrc ||
                    ''
                );
            } else {
                return (
                    this.leftPictureOption.mobileSrc ||
                    this.leftPictureOption.src ||
                    ''
                );
            }
        },
        useRightPicture() {
            if (!this.isMobile) {
                return (
                    this.rightPictureOption.src ||
                    this.rightPictureOption.mobileSrc ||
                    ''
                );
            } else {
                return (
                    this.rightPictureOption.mobileSrc ||
                    this.rightPictureOption.src ||
                    ''
                );
            }
        }
    },
    mounted() {
        this.currentWidth = window.innerWidth;
        this.calcStyle(true);
        global.resize(this.calcStyle);
    },
    methods: {
        calcStyle(flag) {
            if (
                flag !== true &&
                this.isMobile &&
                this.currentWidth &&
                this.currentWidth === window.innerWidth
            ) {
                return; 
            }
            this.currentWidth = window.innerWidth;
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            let minHeight = '';
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            if (type === 'scale') {
                minHeight =
                    (this.$refs.content.offsetWidth * ratio) / 100 + 'px';
            } else if (type === 'fullScreen') {
                minHeight =
                    Math.max(window.innerHeight - this.$el.offsetTop, 500) +
                    'px';
            } else if (type === 'height') {
                minHeight = height + 'px';
            }
            this.minHeight = minHeight;
        },
        calcRealSize() {
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            const ele = this.$el;
            if (ele) {
                if (type === 'scale') {
                    ratio = (ele.offsetHeight / ele.offsetWidth) * 100;
                } else if (type === 'height') {
                    height = ele.offsetHeight;
                }
            }
            return {
                type: sizeOption.type,
                mobileType: sizeOption.mobileType,
                ratio: this.isMobile ? sizeOption.ratio : ratio,
                mobileRatio: this.isMobile ? ratio : sizeOption.mobileRatio,
                height: this.isMobile ? sizeOption.height : height,
                mobileHeight: this.isMobile
                    ? height
                    : sizeOption.mobileHeight
            };
        },
        showRegisterPop(action) {
            if (action.type !== 'callback') {
                return; 
            }
            if (!this.user) {
                let role = action.registerRole || '';
                let tag = action.tag || '';
                signLog.register({
                    role,
                    registerData: {
                        tag
                    }
                });
            } else {
                util.toast(
                    this.$t('md-cta-two-column-simple.youAreAlreadyLogged'),
                    2000
                );
            }
        }
    },
    unmounted() {
        global.resize(this.calcStyle, true);
    },
    components: {
        BannerButton
    }
};
